import React, { useCallback } from 'react'

import clsx from 'clsx'

import GoogleIcon from '$commonSrc/google-icon.svg'
import InteractiveElement from '$extensionSrc/components/InteractiveElement'

import './ContinueWithGoogle.scss'

/*
 * This component uses the HTML provided by
 * https://developers.google.com/identity/branding-guidelines#download-brand-icons
 * in order to be compliant with Google's branding requirements
 */
export default function ContinueWithGoogle({
  redirectUrl,
  iconOnly = false, // If true, the button is a circle with only the Google Icon, no text
  text = 'Continue with Google',
}: {
  redirectUrl: string
  iconOnly?: boolean
  text?: 'Continue with Google' | 'Google'
}) {
  const handleClick = useCallback(() => {
    window.location.assign(redirectUrl)
  }, [redirectUrl])

  return (
    <div className={clsx('ContinueWithGoogle', iconOnly && 'icon-only')}>
      <InteractiveElement
        className="gsi-material-button"
        onClick={handleClick}
        role="link"
        aria-label={text}
      >
        <div className="gsi-material-button-state" />
        <div className="gsi-material-button-content-wrapper">
          <div className="gsi-material-button-icon">
            <GoogleIcon aria-hidden className="google-icon" />
          </div>
          <span
            className={clsx(
              iconOnly && 'icon-only-label',
              !iconOnly && 'gsi-material-button-contents',
            )}
            aria-hidden={iconOnly}
          >
            {text}
          </span>
        </div>
      </InteractiveElement>
    </div>
  )
}
